import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material"
import { BaseDialogComponent } from "../../../../../base/dialog-base/dialog-base.component"
import { JSONRpcResponse } from "../../../../../Interfaces/JSONRpcResponse"
import { FormDialogFormulaireWithSFComponent } from "../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component"
import { DialogService, FormulaireService, StateService, DocumentService } from "../../../../../services"
import { EventEmitter,Output} from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { ErrorCodes } from '../../../../../constants/ErrorCodes'

const KEY = 'formulaire-listing'
@Component({
  selector: 'atyl-formulaire-listing',
  templateUrl: './formulaire-listing.component.html',
  styleUrls: ['./formulaire-listing.component.scss']
})
@Stringable({
	path: 'views/partials/content/listing/formulaire-listing',
	key: KEY,
})
export class FormulaireListing extends BaseDialogComponent implements OnInit {
    
    @StringableValues(KEY) strings: any
    
  dossier: any
  listGroup: any[] = [];
  listFormulaires: any[] = [];
  showList: boolean = false;
  selectedFormulaire: any[] = [];
  loadedForm: any;
  intervention: any;
  @Output() onFormClosed = new EventEmitter<any>();
  
  
  constructor(
    private stateService: StateService,
    private documentService: DocumentService,
    private formulaireService: FormulaireService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    changeDetectorRef: ChangeDetectorRef,
    private dialog: MatDialog,
    dialogRef: MatDialogRef<FormulaireListing>,
    dialogService: DialogService
  ) {
    super(dialogRef, dialogService, changeDetectorRef)
  }

  ngOnInit() {
    
     if (this.data != undefined && this.data.intervention != undefined  && this.data.intervention) {
            this.intervention = this.data.intervention
     }
    
    this._initDossier()
    this._initFormulaires()
  }

  private _initDossier() {
    this.stateService.dossier.subscribe((dossier: any) => {
      this.dossier = dossier
    })
  }

  selectOrRemove(formulaire: any) {
    console.log('this.selectedFormulaire:',this.selectedFormulaire);
    if (this.selectedFormulaire.indexOf(formulaire) === -1) {
        this.selectedFormulaire.push(formulaire);
    } else {
        this.selectedFormulaire.splice(this.selectedFormulaire.indexOf(formulaire), 1);
    }
}
  addSelectedDocuments(event: MouseEvent) {
   
    let demande_formualire_ID = this.data.document.ID;
    let demande_document_ID = [];
    this.selectedFormulaire.forEach(result => {
        demande_document_ID.push(result['ID']);
    });

    this.formulaireService.addDocumentsAtForm(demande_formualire_ID ,demande_document_ID).subscribe((res: JSONRpcResponse) => {
        if(res){
            console.log('res:',res);
        }
    });
    console.log('ID du formulaire:',demande_formualire_ID);
    console.log('ID des Documents:',demande_document_ID);
}

RemoveSelectedDocuments(event: MouseEvent) {
   
    let demande_formualire_ID = this.data.document.ID;
    let demande_document_ID = [];
    this.selectedFormulaire.forEach(result => {
        demande_document_ID.push(result['ID']);
    });

    this.formulaireService.removeFormulaireAtDocument(demande_formualire_ID ,demande_document_ID).subscribe((res: JSONRpcResponse) => {
        if(res){
            console.log('res:',res);
        }
    });
    console.log('ID du formulaire:',demande_formualire_ID);
    console.log('ID des Documents:',demande_document_ID);
}
  private _initFormulaires() {
	let _opts:any={
					getAll:true,
				
	}
    this.formulaireService.getformulairelist(this.dossier.ID,_opts).subscribe((formulaires: JSONRpcResponse) => {
        if(formulaires){
        console.log('formulaire:',formulaires);
        formulaires.result.forEach(element => {
            //element['form'].ID = element.ID;
            this.listFormulaires.push(element);
        });
        }
	    this.showList = this.listFormulaires.length > 0 ;
        let demande_formualire_ID = this.data.document.ID;
        let tab =[];
        console.log('demande_formulaire.ID:',demande_formualire_ID);
        this.documentService.getFormulairesAtDocument(demande_formualire_ID).subscribe((docs: JSONRpcResponse) => {
            console.log('docs:',docs);
            if(!docs){
                throw new Error(ErrorCodes[docs.error.code].long || docs.error.message)
            }else{
                docs.result.forEach(index => {
                    tab.push(index.ID);
                });
                this.listFormulaires.forEach(list => {
                    if(tab.includes(list.ID)){
                        list.checked = true;
                        this.selectedFormulaire.push(list);
                    }else{
                        list.checked = false;
                    }
                    console.log('list.checked:',list.checked,' et list:', list);

                });
            }
          
        });
        console.log(' this.listFormulaires:', this.listFormulaires);
        this.changeDetectorRef.detectChanges()
    })
  }

  tabDossierChange(event: any) {
    console.log(event)
  }
  openFormulaire(event: any) {
    this.dialogService.closeAll()
    console.log("openFormulaire",event);
    this.dialogService.open(FormDialogFormulaireWithSFComponent, {
      data: {
        create: true,
        idAForm: event.value.IdForm,
        v3: true,
        title: event.value.libelle,
        key: event.value.key,
        dossier: this.dossier,
        intervention: this.intervention
      },
     width: "90vw",
      height: '90vh',
      resizable: true,
      minimizable: true,
      maximizable: true,
      draggable: true,
    }, (result: any) => {
            console.log('openFormulaire close',result);
            this.onFormClosed.emit(result);
      })
  }

}
